import moment from "moment"

// колко символа е кодът за двуфакторна автентикация
export const CODE_LENGTH = 6

// след колко секунди може да се поиска нов код
export const RESEND_COOLDOWN = 30

/**
 * Префиксът на ендпойнтите според типа вход (админ или партньор)
 */
export const authPrefix = (role) => (role === "admin" ? "admins" : "partners")

/**
 * Пътят до страницата с кода, като пази езика, редиректа и tenant-а
 */
export const twoFactorPath = (role, challengeId, params = {}) => {
  let search = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      search.set(key, value)
    }
  })

  let query = search.toString()

  return (
    "/login/" +
    (role || "partners") +
    "/2fa/" +
    encodeURIComponent(challengeId) +
    (query ? "?" + query : "")
  )
}

/**
 * Оставя само позволените символи в кода
 * (ако кодовете станат буквено-цифрени, регулярният израз се сменя тук)
 */
export const sanitizeCode = (value) => String(value ?? "").replace(/\D/g, "")

// "2026-09-11 17:11:07" идва в часовата зона на приложението,
// затова се чете като локално време (както навсякъде другаде в системата)
const DATETIME_FORMATS = ["YYYY-MM-DD HH:mm:ss", moment.ISO_8601]

const toSeconds = (value) => {
  if (typeof value === "number" && isFinite(value)) {
    return Math.max(0, Math.floor(value))
  }

  if (typeof value === "string" && value.trim() !== "" && !isNaN(Number(value))) {
    return Math.max(0, Math.floor(Number(value)))
  }

  return null
}

/**
 * Оставащото време се чете от различни възможни полета в отговора,
 * за да не зависи страницата от точното именуване в API-то
 */
export const parseSecondsLeft = (data) => {
  if (data === null || data === undefined) {
    return null
  }

  let source = typeof data === "object" ? data : { seconds_left: data }

  // готов брой секунди
  let seconds = [
    source.seconds_left,
    source.time_left,
    source.seconds,
    source.remaining,
  ]

  for (let i = 0; i < seconds.length; i++) {
    let value = toSeconds(seconds[i])

    if (value !== null) {
      return value
    }
  }

  // момент на изтичане
  let expiresAt = source.expires_at || source.expire_at || source.valid_until

  if (expiresAt) {
    let parsed = moment(String(expiresAt), DATETIME_FORMATS)

    if (parsed.isValid()) {
      return Math.max(0, parsed.diff(moment(), "seconds"))
    }
  }

  return toSeconds(source.expires_in) ?? toSeconds(source.ttl)
}

/**
 * Секунди към mm:ss
 */
export const formatSeconds = (seconds) => {
  let safe = Math.max(0, Math.floor(Number(seconds) || 0))
  let minutes = Math.floor(safe / 60)
  let rest = safe % 60

  return (
    String(minutes).padStart(2, "0") + ":" + String(rest).padStart(2, "0")
  )
}

/**
 * Съобщението за грешка от отговора на API-то
 * (message или първата грешка от валидацията)
 */
export const getErrorMessage = (err, fallback) => {
  let data = err?.response?.data

  if (data) {
    if (typeof data.message === "string" && data.message) {
      return data.message
    }

    if (data.errors && typeof data.errors === "object") {
      let first = Object.values(data.errors)[0]

      if (Array.isArray(first) && first[0]) {
        return first[0]
      }

      if (typeof first === "string") {
        return first
      }
    }
  }

  return fallback
}
